const getSanitizedRedirect = (untrustedUrl, fallback = null) => {
  if (!untrustedUrl && fallback) {
    return fallback;
  }

  return `/redirect/?next=${escape(untrustedUrl)}`; // backend will return a valid URL if next is empty
};

export default getSanitizedRedirect;
